// returns true if screenWidth > 1200, which would mean desktop resolution

const checkNotMobile = (screenWidth: number) => {

    return (screenWidth > 1279)

}

export default checkNotMobile